import ISHome from '@/views/ISHome.vue';
import IoT from '@/views/IoT.vue';
import InitialStateReceipt from '@/views/receipts/InitialState.vue';

export default [{
	path: '/',
	name: 'home',
	component: ISHome,
	meta: {
		requiresAuth: true,
		title: 'Home'
	}
},
{
	path: '/subscriptions/iot',
	name: "subscriptions/iot",
	component: IoT,
	meta: {
		requiresAuth: true,
		title: 'IoT Subscription'
	}
},
{
	path: '/receipt/:id',
	name: 'receipt',
	component: InitialStateReceipt,
	meta: {
		requiresAuth: true,
		title: 'Receipt'
	}
}
];



// WEBPACK FOOTER //
// ./src/router/initialstate.js